import React from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Box from "components/common/Box";
import Stack from "components/common/Stack";
import Text from "components/common/Text";

const PortfolioHealthCheckBanner = ({ onClick }) => (
  <Box
    onClick={onClick}
    role={onClick ? "button" : undefined}
    tabIndex={onClick ? 0 : undefined}
    onKeyDown={
      onClick
        ? (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onClick();
            }
          }
        : undefined
    }
    sx={{
      position: "relative",
      width: "100%",
      minHeight: 113,
      borderRadius: "19px",
      overflow: "hidden",
      cursor: onClick ? "pointer" : "default",
      background:
        "linear-gradient(180deg, #1A0008 15%, #3D0015 62%, #5C0011 125%)",
      border: "1px solid rgba(255,255,255,0.18)",
      boxShadow:
        "0px 2px 19px -2px rgba(255,255,255,0.1), 0px 4px 19px -1px rgba(255,255,255,0.1)",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: 2,
      py: 1.75,
    }}
  >
    <Stack spacing={1.5} sx={{ maxWidth: "55%", zIndex: 1 }}>
      <Stack spacing={0.5}>
        <Text
          sx={{
            fontWeight: 800,
            fontSize: 16,
            color: "#fff",
            letterSpacing: "-0.48px",
            lineHeight: 1.2,
          }}
        >
          Portfolio Health Check
        </Text>
        <Text
          sx={{
            fontWeight: 500,
            fontSize: 12,
            color: "#93C5FD",
            lineHeight: "16px",
          }}
        >
          Free Portfolio Audit
        </Text>
      </Stack>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          alignSelf: "flex-start",
          px: 1.75,
          py: 1.25,
          borderRadius: "12px",
          background: "linear-gradient(90deg, #E31E24, #C62828)",
          border: "1px solid rgba(255,255,255,0.2)",
          boxShadow:
            "0px 0px 14px 0px rgba(227,30,36,0.25), 0px 10px 24px -8px rgba(0,0,0,0.4)",
        }}
      >
        <Text sx={{ fontWeight: 700, fontSize: 12, color: "#fff", lineHeight: 1 }}>
          Know More
        </Text>
        <ArrowForwardIcon sx={{ fontSize: 14, color: "#fff" }} />
      </Box>
    </Stack>

    <Box
      component="img"
      src="/images/product-info/phc-3d.png"
      alt=""
      sx={{
        position: "absolute",
        right: 8,
        bottom: -8,
        width: 112,
        height: 131,
        objectFit: "contain",
        pointerEvents: "none",
      }}
    />
  </Box>
);

export default PortfolioHealthCheckBanner;
